<template>
  <div class="myBreadcrumbBox">
    <!-- <div class="title">
      首页 <span>></span> {{ title }} <span v-if="title02">></span>
      {{ title02 }}
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      title02: "",
    };
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.myBreadcrumbBox {
  .title {
    font-size: 1.1rem;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #999999;
    line-height: 1.3rem;
  }
}
</style>